/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * What is the way the work was handed in.
 */
export const WorkOrigin = /* #__PURE__ */ parsers.exactly('uploaded_files', 'github', 'gitlab');
